module.exports = __webpack_public_path__ + "static/media/Lib.6223230a.png";